import React, { useRef, useEffect } from 'react';
import { Group, Image, Transformer } from 'react-konva';
import useImage from 'use-image';
// Component for each product image
const CanvasImage = ({ side, imageIndex, imageURL, imageDimensions, updateImageDimensions, updatePosition, isSelected, onSelect }) => {
    const uploadedImageRef = useRef(null);
    const transformerRef = useRef(null);
    const groupRef = useRef(null);
    const [canvasImage] = useImage(imageURL, 'anonymous');
    useEffect(() => {
        if (isSelected) {
            transformerRef.current.nodes([uploadedImageRef.current]);
            transformerRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);
    if (imageURL == null || imageDimensions == null) {
        return null;
    }
    return (React.createElement(Group, { ref: groupRef },
        React.createElement(Image, { width: imageDimensions.width, height: imageDimensions.height, x: imageDimensions.position.x, y: imageDimensions.position.y, rotation: imageDimensions.position.rotation, image: canvasImage, ref: uploadedImageRef, onClick: onSelect, onTap: onSelect, draggable: true, fill: "transparent", onDragStart: onSelect, onDragEnd: (e) => {
                const node = uploadedImageRef.current;
                if (node) {
                    updateImageDimensions(imageIndex, Math.max(5, node.width()), Math.max(node.height()), false);
                    updatePosition(imageIndex, side, { x: e.target.x(), y: e.target.y(), rotation: e.target.rotation() });
                }
            }, onTransformEnd: (e) => {
                const node = uploadedImageRef.current;
                if (node) {
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    // we will reset it back
                    node.scaleX(1);
                    node.scaleY(1);
                    updateImageDimensions(imageIndex, Math.max(5, node.width() * scaleX), Math.max(node.height() * scaleY), false);
                    updatePosition(imageIndex, side, { x: node.attrs.x, y: node.attrs.y, rotation: node.rotation() });
                }
            } }),
        isSelected && (React.createElement(Transformer, { ref: transformerRef, flipEnabled: false, rotateEnabled: true, anchorFill: "#74AFC2", borderStroke: "#74AFC2", borderStrokeWidth: 2, anchorCornerRadius: 4, anchorSize: 16, enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'], boundBoxFunc: (oldBox, newBox) => {
                // limit resize
                if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
                    return oldBox;
                }
                return newBox;
            } }))));
};
export default CanvasImage;
